export const FAQLIST = [
  {
    question: '꺼미 NFT는 어떤 블록체인을 이용하나요?',
    answer: '꺼미NFT는 클레이튼(KLAYTN) 블록체인을 이용하고 있습니다.',
  },
  {
    question: '커뮤니티 (디스코드, 트위터)는 어떻게 참여할 수 있나요?',
    answer:
      '커뮤니티 채널은 홈페이지 우측 상단 채널 별 아이콘을 눌러서 참여할 수 있습니다.',
  },
  {
    question: '꺼미 NFT는 어떻게 구매하나요?',
    answer:
      '1. 카이카스 지갑 생성\n2. 민팅 페이지에서 카이카스 지갑 연결 후, 꺼미 NFT 구매 가능',
  },
  {
    question: '리빌은 어떻게 참여하나요?',
    answer:
      '11월 11일 (금)에 자동으로 리빌되며 오픈씨에서 리프레쉬 버튼을 누르면 확인할 수 있습니다.',
  },
  {
    question: '랭킹은 어떻게 확인할 수 있나요?',
    answer: '추후에 공지해드릴 예정이며, 11월 중으로 진행 될 예정입니다.',
  },
  {
    question: 'KLIP 지갑 사용할 수 있나요?',
    answer:
      '카이카스와 메타지갑만 사용 가능하며, 클립 지갑은 추후 지원할 예정입니다.',
  },
  {
    question: '2차 판매 로열티가 있나요?',
    answer: '2차 판매 로열티는 7.5%입니다.',
  },
  {
    question: '꺼미NFT는 저작권을 활용할 수 있나요?',
    answer:
      '소유권만 인정하고 있으며 IP 임의 변형, 2차 창작 그리고 상업적 이용이 불가합니다.',
  },
];
